var playState = 0; // 0 结束  1 开始  2 暂停
var heartBeatAudio;
var playBtn;
var cover;
var cd;
var canvasArea;
var mengceng;
var loading_icon;
var header;
var content;
var music = new Music();
var isTest = false;
var hasData = false;
var id = 0;
var isFirstLoad = 0;

$(function() {
  heartBeatAudio = document.getElementById("heartBeatAudio");
  playBtn = $("#playBtn");
  cover = $("#cover");
  cd = $("#cd");
  canvasArea = $("#visualizer_wrapper");
  mengceng = $("#mengceng");
  loading_icon = $("#loading");
  header = $("#header");
  content = $("#content");
  playBtn.css("display", "none");
});

$(function() {
  id = GetQueryString("id");
  id = encodeURIComponent(id);
  var test = GetQueryString("t");
  $('canvas').width($('.cover').height() - 2);
  $('canvas').height($('.cover').height() - 2);
  if (null != test) {
    isTest = true;
  }
  var requestHead = isTest ? "http://wechat.d.extantfuture.com/hb?" : "https://zc.meng-dong.com/hb?"
  var url = requestHead + "id=" + id;
  //console.log(url);
  //根据ID请求头像url和mp3的url
  $.ajax({
    type: "get",
    url: url,
    async: true,
    dataType: "json",
    success: function(data) {
      if (data.code == 0) {
        cover.attr("src", data.data.headImgUrl);
        hasData = data.data.hasData;
        //console.log(hasData);
        if (hasData) {
          $("#chart_icon").show();
        }
        if (null != data.data.soundUrl && "" != data.data.soundUrl) {
          //初始化audio对象
          heartBeatAudio.src = data.data.soundUrl;
          playBtn.css("display", "block");
        } else {
          playBtn.css("display", "none");
        }
        //设置内容
        document.title = data.data.userNick + " " + data.data.pregnancyData + "的胎心音日记";
        header.html(data.data.userNick + "&nbsp;&nbsp;&nbsp;&nbsp;" + data.data.pregnancyData);
        content.html(data.data.content);
        loading_icon.css("display", "none");
      } else {
        //loading_icon.css("display", "none");
        console.log("request failed data=" + data);
      }
    }
  });
});

function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

function playOperation() {
  if (heartBeatAudio.paused) {
    if (isFirstLoad == 0) {
      play();
    } else {
      heartBeatAudio.play();
      playBtn.attr("src", "img/stop.png");
      mengceng.css("display", "block");
      canvasArea.css("display", "block");
      music.showBottom();
      music.start();
    }
  } else {
    pause();
  }
}

function play() {
  heartBeatAudio.volume = 1;
  heartBeatAudio.load();
  heartBeatAudio.onerror = function() {
    prompt("音频正在重新生成，请稍后再试...", 'alert-warning', 2500);
  };
  playBtn.attr("src", "img/stop.png");
  mengceng.css("display", "block");
  canvasArea.css("display", "block");
  playState = 1;
  $('.loading-gif').show();
  heartBeatAudio.addEventListener("canplaythrough", canplayHandler);
}

function canplayHandler() {
  $('.loading-gif').hide();
  isFirstLoad = 1;
  heartBeatAudio.play();
  music.showBottom();
  music.start();
}

function pause() {
  $('.loading-gif').hide();
  heartBeatAudio.pause();
  playBtn.attr("src", "img/play.png");
  mengceng.css("display", "none");
  canvasArea.css("display", "none");
  playState = 2;
}

function forwardToJd() {
  window.location.href = "https://www.meng-dong.com";
}

function linkToChart() {
  var chartHerf = isTest ? id + "&t=1" : id;
  window.location.href = "./chart.html?id=" + chartHerf;
}

function prompt(message, style, time)
{
    style = (style === undefined) ? 'alert-success' : style;
    time = (time === undefined) ? 1200 : time;
    $('.alert')
        .addClass('alert ' + style)
        .html(message)
        .show()
        .delay(time)
        .fadeOut();
};
